import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/DefaultSelectDropdown';

interface BooleanFieldElementProps {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  onBlur?: (checked: boolean) => void;
}

const BooleanFieldElement = ({ id, checked, onChange, onBlur }: BooleanFieldElementProps) => {
    const handleValueChange = (value: string) => {
        const booleanValue = value === 'true';
        onChange(booleanValue);
        if (onBlur) {
            onBlur(booleanValue);
        }
    };
    
    return (
        <Select
            value={checked ? 'true' : 'false'}
            onValueChange={handleValueChange}
        >
            <SelectTrigger id={id} className="w-full">
                <SelectValue />
            </SelectTrigger>
            <SelectContent>
                <SelectItem value="true">True</SelectItem>
                <SelectItem value="false">False</SelectItem>
            </SelectContent>
        </Select>
    );
};

BooleanFieldElement.displayName = "BooleanFieldElement";

export { BooleanFieldElement };